import Job from "./Job";
export default class Request {
  private name: string;
  private requestId: string;
  private _id: string;
  private jobType: string;
  private sourceType: string;
  private isSubmitted: boolean;
  private notes: string;
  private createdDate: string;
  private createdBy: string;
  private updatedDate: string;
  private updatedBy: string;
  private notificationList: Array<string>;
  private requestor: Object;
  private jobs: Array<Job>;
  private submittedDate: string;

  constructor(
    name: string,
    requestId: string,
    _id: string,
    jobTypeId: string,
    sourceType: string,
    isSubmitted: boolean,
    notes: string,
    createdDate: string = null,
    createdBy: string = null,
    updatedDate: string = null,
    updatedBy: string = null,
    notificationList: Array<string>,
    requestor: Object,
    jobs: Array<Job>,
    submittedDate: string = null
  ) {
    this.name = name;
    this.requestId = requestId;
    this._id = _id;
    this.jobType = jobTypeId;
    this.sourceType = sourceType;
    this.isSubmitted = isSubmitted;
    this.notes = notes;
    this.createdDate = createdDate;
    this.createdBy = createdBy;
    this.updatedDate = updatedDate;
    this.updatedBy = updatedBy;
    this.requestor = requestor;
    this.notificationList = notificationList;
    this.jobs = jobs;
    this.submittedDate = submittedDate;
  }
}
